module.exports = __webpack_public_path__ + "img/gdb.5446576e.png";